import { FunctionComponent } from 'react';

import './card-waste-management-report-list-item.scss';


export interface CardWasteManagementReportListItemProps {
	/**
	 * (Optional) Disabled state
	 */
	disabled?: boolean;
	/**
	 * (Optional) Archived state
	 */
	archived?: boolean;
}
export const CardWasteManagementReportListItem: FunctionComponent<CardWasteManagementReportListItemProps> = (props): JSX.Element => {
	const { disabled, children, archived = false } = props;

	const componentDisabledStyle = disabled ?
		' card-waste-management-report-list-item--disabled' :
		'';

	const componentArchivedStyle = archived ?
		' card-waste-management-report-list-item--archived' :
		'';

	return (
		<div className={`card-waste-management-report-list-item${componentDisabledStyle}${componentArchivedStyle}`}>
			<div
				className='card-waste-management-report-list-item__content'
				role='button'
				tabIndex={0}
			>
				{children}
			</div>
		</div>
	);
};
